<script setup lang="ts">
    const query = computed(() => useRoute().query);

    const { lang } = useLanguage();
    const { t } = useI18n();

    const { searchResult, pending } = useSammySearch(query);

    useHead({
        htmlAttrs: {
            lang: lang.value
        }
    });

    usePageTitle();
</script>

<template>
    <div v-if="searchResult?.hits?.hits?.length > 0 && !pending">
        <FachkreisSearch :search-result="searchResult" />
    </div>

    <div
        v-else
        class="container"
    >
        <div
            v-if="pending"
            class="spinner"
        >
            <LoadingSpinner />
        </div>

        <div
            v-else-if="!searchResult?.hits?.hits?.length"
            class="empty-search"
        >
            <div v-if="query.query">
                <p>{{ t('search.noResultStatus') }}</p>
                <p>{{ t('search.noResult') }} "{{ query.query }}"</p>
            </div>

            <div v-else>
                <p>{{ t('search.emptyCta') }}</p>
                <p>{{ t('search.empty') }}</p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '@/assets/scss/fachkreis/fachkreis-search.scss';
</style>
